<template>
    <div >
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <p v-on="on">{{calculateTime(params.node.data.timestamp)}}</p>
      </template>
      <span>{{
                new Date(params.node.data.timestamp).toLocaleString()
                }}</span>
    </v-tooltip>
    </div>
</template>
<script>
import Vue from "vue";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
export default Vue.extend({
  
  data: () => ({
  }),
  methods: {
    calculateTime(date) {
      return this.params.context.componentParent.calculateTime(date)
    }
  },
  created() {
    // Add locale-specific relative date/time formatting rules.
    TimeAgo.addLocale(en);
    // Create relative date/time formatter.
    this.timeAgo = new TimeAgo("en-US");
  }
})
</script>